import EventDTO from '../models/event';

interface Options {
  plural: boolean;
  casing: 'lower' | 'upper' | 'first_letter';
}

const getCustomTicketLabel = (event: EventDTO, { plural, casing }: Options) => {
  let label = event.custom_ticket_label || 'entrada';
  if (plural) {
    label = `${label}s`;
  }
  if (casing === 'lower') {
    label = label.toLowerCase();
    return label;
  }
  if (casing === 'upper') {
    label = label.toUpperCase();
    return label;
  }
  if (casing === 'first_letter') {
    label = label.charAt(0).toUpperCase() + label.slice(1);
    return label;
  }
  return label;
};

export default getCustomTicketLabel;
